import React from 'react';
import LazyImage from '../../components/LazyImage';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-[400px] md:min-h-[448px] lg:h-[448px] flex items-center justify-center">
      {/* Background Image */}
      <LazyImage 
        src="/images/mofu.webp" 
        alt="Financial charts background" 
        className="absolute inset-0 w-full h-full object-cover object-[30%] md:object-center"
        priority={true}
        preload={true}
        sizes="100vw"
      />
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-[#1A2A44] bg-opacity-80 z-10"></div>
      
      {/* Content Overlay */}
      <div className="relative z-20 mx-auto px-4 md:px-10 lg:px-32 w-full py-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Main Title */}
          <h1 className="text-[#FFFFFF] text-[30px] md:text-[42px] lg:text-[37px] font-[700] leading-tight mb-6  md:max-w-4xl mx-auto">
            {/* Mobile version with line breaks */}
            <span className="block sm:hidden">
              10 Tips to Increase<br />
              Your Chance of<br />
              Scoring a<br />
              10x Win with<br />
              Resource Juniors
            </span>
            {/* Desktop/Tablet version without line breaks */}
            <span className="hidden sm:block">
              10 Tips to Increase Your Chance of Scoring a 10x Win with Resource Juniors
            </span>
          </h1>
          
          {/* Horizontal Line */}
          <div className="w-full h-[2px] bg-[#FFFFFF] mb-6 mx-auto"></div>
          
          {/* Subtitle */}
          <div className="max-w-2xl mx-auto">
            <p className="text-[#FFFFFF] text-[18px] md:text-[22px] lg:text-[24px] font-[400] italic leading-relaxed">
              Practical Insights from a <span className="not-italic font-[600]">25-Year Veteran</span> to Help You Navigate the Junior Mining Space
            </p>
          </div>

          {/* CTA Button */}
          <div className="mt-8">
            <a
              href="https://the-wealthy-miner.mn.co/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#0B6054] text-white px-8 md:px-12 lg:px-16 py-3 md:py-4 rounded-[10px] font-[700] text-[16px] md:text-[18px] lg:text-[20px] hover:bg-[#0d7a6b] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[#0B6054] focus:ring-opacity-50"
            >
              Join The Wealthy Miner Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
